import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import apiConfig from "../../../apiConfig";

const GetAllSeller = () => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSellers();
  }, []);

  const fetchSellers = async () => {
    try {
      const res = await axios.get(
        `${apiConfig.baseUrl}${apiConfig.GetAllSeller}`,
      );
      setSellers(res.data.data || []);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      setLoading(true);
      const res = await axios.put(
        `${apiConfig.baseUrl}${apiConfig.GetSellerUpdateStatus}/${id}`,
      );
      toast.success(`Seller ${status}`);
      fetchSellers();
    } catch (error) {
      toast.error("Action failed");
    } finally {
      setLoading(false);
    }
  };

  const deleteSeller = async (id) => {
    try {
      setLoading(true);
      await axios.delete(`${apiConfig.baseUrl}${apiConfig.DeleteSeller}/${id}`);
      toast.success("Seller deleted");
      setSellers((prev) => prev.filter((seller) => seller._id !== id));
      fetchSellers();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // if (loading) {
  //     return <p className="text-center mt-10">Loading sellers...</p>;
  // }

  return (
    <div className="p-4 sm:p-6">
      <h2 className="text-2xl font-bold mb-4">All Sellers</h2>

      <div className="hidden md:block overflow-x-auto">
        <table className="w-full border rounded-lg">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 text-left">Name</th>
              <th className="p-3">Email</th>
              <th className="p-3">Phone</th>
              <th className="p-3">Shop</th>
              <th className="p-3">GST</th>
              <th className="p-3">Status</th>
              <th className="p-3">sellerId</th>
              <th>bankName</th>
              <th>holderName</th>
              <th>ifscCode</th>
              <th>accountNumber</th>
              <th className="p-3">Action</th>
              <th className="p-3">Delete Seller</th>
            </tr>
          </thead>
          <tbody>
            {sellers?.length === 0 ? (
              <tr>
                <td colSpan="7" className="p-3 text-center text-gray-500">
                  No sellers found.
                </td>
              </tr>
            ) : (
              sellers?.map((seller) => (
                <tr key={seller._id} className="border-t">
                  <td className="p-3">{seller.fullName}</td>
                  <td className="p-3">{seller.email}</td>
                  <td className="p-3">{seller.phone}</td>
                  <td className="p-3">{seller.shopName}</td>
                  <td className="p-3">{seller.gstNumber}</td>
                  <td className="p-3">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-medium
                    ${
                      seller.status === "approved"
                        ? "bg-green-100 text-green-700"
                        : seller.status === "rejected"
                          ? "bg-red-100 text-red-700"
                          : "bg-yellow-100 text-yellow-700"
                    }`}
                    >
                      {seller.status}
                    </span>
                  </td>
                  <td className="p-3">{seller.sellerId}</td>
                  <td>
                    {seller.bankDetails?.bankName
                      ? seller.bankDetails?.bankName
                      : "-"}
                  </td>
                  <td>
                    {seller.bankDetails?.holderName
                      ? seller.bankDetails?.holderName
                      : "- "}
                  </td>
                  <td>
                    {seller.bankDetails?.ifscCode
                      ? seller.bankDetails?.ifscCode
                      : "-"}
                  </td>
                  <td>
                    {seller.bankDetails?.accountNumber
                      ? seller.bankDetails?.accountNumber
                      : "-"}
                  </td>
                  {seller.status == "active" ? (
                    <td className="p-3 space-x-2">
                      <div>Approverd</div>
                    </td>
                  ) : (
                    <td className="p-3 space-x-2">
                      <button
                        onClick={() => updateStatus(seller._id, "approved")}
                        className="bg-green-600 text-white px-3 py-1 rounded text-sm"
                      >
                        {loading ? "Loading..." : "Approve"}
                      </button>
                    </td>
                  )}
                  <td className="p-3">
                    <button
                      onClick={() => deleteSeller(seller._id)}
                      className="bg-red-600 text-white px-3 py-1 rounded text-sm"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="md:hidden space-y-4">
        {sellers?.map((seller) => (
          <div key={seller._id} className="bg-white shadow rounded-lg p-4">
            <h3 className="font-semibold text-lg">{seller.fullName}</h3>
            <p className="text-sm text-gray-600">{seller.email}</p>
            <p className="text-sm">📞 {seller.phone}</p>
            <p className="text-sm">🏪 {seller.shopName}</p>
            <p className="text-sm">GST: {seller.gstNumber}</p>

            <span
              className={`inline-block mt-2 px-3 py-1 rounded-full text-sm
              ${
                seller.status === "active"
                  ? "bg-green-100 text-green-700"
                  : seller.status === "rejected"
                    ? "bg-red-100 text-red-700"
                    : "bg-yellow-100 text-yellow-700"
              }`}
            >
              {seller.status}
            </span>

            <div className="flex gap-2 mt-3">
              <button
                onClick={() => updateStatus(seller._id, "approved")}
                className="flex-1 bg-green-600 text-white py-2 rounded"
              >
                Approve
              </button>
            </div>
          </div>
        ))}
      </div>
      {loading && (
        <div>
          <p className="text-center mt-10">Loading sellers...</p>
        </div>
      )}
    </div>
  );
};

export default GetAllSeller;
